import { fromJS } from 'immutable';
import _ from 'lodash';

import {
  ASSIGN_RESOURCES_TO_TASKS,
} from '../actions/tasks';
import {
  fetchTasksRoutine,
  saveJobRoutine,
  editTaskRoutine,
  removeTasksRoutine,
  fetchTaskRoutine,
  uploadTasksRoutine
} from '../routines';
import { updateOrAddMap } from './helper';
import { toMap } from '../../utils/helper';

const initialState = fromJS({
  tasks: {},
  task: {},
  loading: false,
  selectedTasks: [],
});

export default function (state = initialState, action) {
  switch (action.type) {
    case fetchTasksRoutine.TRIGGER:
      return state.set('loading', true);
    case fetchTasksRoutine.SUCCESS:
      return state.set('tasks', fromJS(action.payload.response));
    case fetchTasksRoutine.FAILURE:
      return state.set('error', action.error).set('loading', false);
    case fetchTaskRoutine.SUCCESS:
      return state.set('task', fromJS(action.task)).set('loading', false);
    case fetchTaskRoutine.FAILURE:
      return state.set('error', action.error).set('loading', false);

    case uploadTasksRoutine.SUCCESS:
      return state.updateIn(['tasks'], (tasks) => tasks.merge(fromJS(toMap(action.tasks))));

    case ASSIGN_RESOURCES_TO_TASKS:
      const assignments = action.tasks.reduce((res, task) => _.assign(res, {
        [task.id]: {
          stages: action.stages,
          changed: true,
        },
      }), {});

      return state.mergeDeepIn(['tasks'], fromJS(assignments));
    case removeTasksRoutine.SUCCESS:
      const deletedTaskIds = action.payload.request.tasks.map((task) => task.id);
      return state.updateIn(['tasks'], (tasks) => {
        return tasks.filter((task, taskId) => !task.deleted && deletedTaskIds.indexOf(taskId) < 0);
      });
    case saveJobRoutine.SUCCESS:
      return state;
    case editTaskRoutine.SUCCESS:
      return state
        .updateIn(['tasks'], updateOrAddMap(fromJS(action.payload.task)))
        .set('task', fromJS(action.payload.task)).set('saving', false);
    case editTaskRoutine.FAILURE:
      return state.set('error', action.error).set('saving', false);
    case editTaskRoutine.FULFILL:
      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/tasks.js